// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-616dda05] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.color-picker[data-v-616dda05] {
  display: flex;
  overflow: hidden;
  align-content: flex-end;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: content-box !important;
  width: 176px;
  padding: 8px;
  border-radius: 3px;
}
.color-picker--advanced-fields[data-v-616dda05] {
  width: 264px;
}
.color-picker__simple[data-v-616dda05] {
  display: grid;
  grid-template-columns: repeat(auto-fit, var(--default-clickable-area));
  grid-auto-rows: var(--default-clickable-area);
}
.color-picker__simple-color-circle[data-v-616dda05] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--default-clickable-area) - 10px);
  height: calc(var(--default-clickable-area) - 10px);
  min-height: calc(var(--default-clickable-area) - 10px);
  margin: auto;
  padding: 0;
  color: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  font-size: 16px;
}
.color-picker__simple-color-circle[data-v-616dda05]:focus-within {
  outline: 2px solid var(--color-main-text);
}
.color-picker__simple-color-circle[data-v-616dda05]:hover {
  opacity: 0.6;
}
.color-picker__simple-color-circle--active[data-v-616dda05] {
  width: calc(var(--default-clickable-area) - 6px);
  height: calc(var(--default-clickable-area) - 6px);
  min-height: calc(var(--default-clickable-area) - 6px);
  transition: all 100ms ease-in-out;
  opacity: 1 !important;
}
.color-picker__advanced[data-v-616dda05] {
  box-shadow: none !important;
}
.color-picker__navigation[data-v-616dda05] {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
[data-v-616dda05]  .vc-chrome {
  width: unset;
  background-color: var(--color-main-background);
}
[data-v-616dda05]  .vc-chrome-color-wrap {
  width: 30px;
  height: 30px;
}
[data-v-616dda05]  .vc-chrome-active-color {
  width: calc(var(--default-clickable-area) - 10 px);
  height: calc(var(--default-clickable-area) - 10 px);
  border-radius: 17px;
}
[data-v-616dda05]  .vc-chrome-body {
  padding: 14px 0 0 0;
  background-color: var(--color-main-background);
}
[data-v-616dda05]  .vc-chrome-body .vc-input__input {
  --input-border-radius: var(--border-radius-element, var(--border-radius-large));
  --input-border-width-offset: calc(var(--border-width-input-focused, 2px) - var(--border-width-input, 2px));
  width: 100%;
  height: var(--default-clickable-area);
  margin: 0;
  padding-inline: calc(var(--border-radius-large) + var(--input-border-width-offset));
  padding-block: var(--input-border-width-offset);
  border: var(--border-width-input, 2px) solid var(--color-border-maxcontrast);
  border-radius: var(--input-border-radius);
  font-size: var(--default-font-size);
  color: var(--color-main-text);
  box-shadow: none;
}
[data-v-616dda05]  .vc-chrome-body .vc-input__input:active:not([disabled]),[data-v-616dda05]  .vc-chrome-body .vc-input__input:hover:not([disabled]),[data-v-616dda05]  .vc-chrome-body .vc-input__input:focus:not([disabled]) {
  --input-border-width-offset: 0px;
  border-color: var(--color-main-text);
  border-width: var(--border-width-input-focused, 2px);
  box-shadow: 0 0 0 2px var(--color-main-background) !important;
}
[data-v-616dda05]  .vc-chrome-body .vc-input__input:active:not([disabled]) + .vc-input__label,[data-v-616dda05]  .vc-chrome-body .vc-input__input:hover:not([disabled]) + .vc-input__label,[data-v-616dda05]  .vc-chrome-body .vc-input__input:focus:not([disabled]) + .vc-input__label {
  color: var(--color-main-text);
}
[data-v-616dda05]  .vc-chrome-body .vc-input__label {
  position: absolute;
  inset-inline: var(--border-width-input-focused, 2px);
  inset-block-start: calc(-1.5 * var(--font-size-small, 13px) / 2);
  max-width: fit-content;
  margin-inline: calc(var(--border-radius-large) - var(--default-grid-baseline));
  margin-block: 0;
  padding-inline: var(--default-grid-baseline);
  font-family: var(--font-face);
  font-size: var(--font-size-small, 13px);
  line-height: 1.5;
  font-weight: 500;
  color: var(--color-text-maxcontrast);
  background-color: var(--color-main-background);
  pointer-events: none;
}
[data-v-616dda05]  .vc-chrome-toggle-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  margin-left: 6px;
  filter: var(--background-invert-if-dark);
}
[data-v-616dda05]  .vc-chrome-toggle-icon {
  width: 24px;
  height: 24px;
  margin: 0;
}
[data-v-616dda05]  .vc-chrome-toggle-icon-highlight {
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  inset: 0;
}
[data-v-616dda05]  .vc-chrome-saturation-wrap {
  border-radius: 3px;
}
[data-v-616dda05]  .vc-chrome-saturation-circle {
  width: 20px;
  height: 20px;
}
.slide-enter[data-v-616dda05] {
  transform: translateX(-50%);
  opacity: 0;
}
.slide-enter-to[data-v-616dda05] {
  transform: translateX(0);
  opacity: 1;
}
.slide-leave[data-v-616dda05] {
  transform: translateX(0);
  opacity: 1;
}
.slide-leave-to[data-v-616dda05] {
  transform: translateX(-50%);
  opacity: 0;
}
.slide-enter-active[data-v-616dda05], .slide-leave-active[data-v-616dda05] {
  transition: all 50ms ease-in-out;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcColorPicker-Dw2wy2tU.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sEAAsE;EACtE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,kDAAkD;EAClD,sDAAsD;EACtD,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;AACd;AACA;EACE,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kDAAkD;EAClD,mDAAmD;EACnD,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,+EAA+E;EAC/E,0GAA0G;EAC1G,WAAW;EACX,qCAAqC;EACrC,SAAS;EACT,mFAAmF;EACnF,+CAA+C;EAC/C,4EAA4E;EAC5E,yCAAyC;EACzC,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,gEAAgE;EAChE,sBAAsB;EACtB,8EAA8E;EAC9E,eAAe;EACf,4CAA4C;EAC5C,6BAA6B;EAC7B,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,8CAA8C;EAC9C,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-616dda05] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.color-picker[data-v-616dda05] {\n  display: flex;\n  overflow: hidden;\n  align-content: flex-end;\n  flex-direction: column;\n  justify-content: space-between;\n  box-sizing: content-box !important;\n  width: 176px;\n  padding: 8px;\n  border-radius: 3px;\n}\n.color-picker--advanced-fields[data-v-616dda05] {\n  width: 264px;\n}\n.color-picker__simple[data-v-616dda05] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, var(--default-clickable-area));\n  grid-auto-rows: var(--default-clickable-area);\n}\n.color-picker__simple-color-circle[data-v-616dda05] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(var(--default-clickable-area) - 10px);\n  height: calc(var(--default-clickable-area) - 10px);\n  min-height: calc(var(--default-clickable-area) - 10px);\n  margin: auto;\n  padding: 0;\n  color: white;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 50%;\n  font-size: 16px;\n}\n.color-picker__simple-color-circle[data-v-616dda05]:focus-within {\n  outline: 2px solid var(--color-main-text);\n}\n.color-picker__simple-color-circle[data-v-616dda05]:hover {\n  opacity: 0.6;\n}\n.color-picker__simple-color-circle--active[data-v-616dda05] {\n  width: calc(var(--default-clickable-area) - 6px);\n  height: calc(var(--default-clickable-area) - 6px);\n  min-height: calc(var(--default-clickable-area) - 6px);\n  transition: all 100ms ease-in-out;\n  opacity: 1 !important;\n}\n.color-picker__advanced[data-v-616dda05] {\n  box-shadow: none !important;\n}\n.color-picker__navigation[data-v-616dda05] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n[data-v-616dda05]  .vc-chrome {\n  width: unset;\n  background-color: var(--color-main-background);\n}\n[data-v-616dda05]  .vc-chrome-color-wrap {\n  width: 30px;\n  height: 30px;\n}\n[data-v-616dda05]  .vc-chrome-active-color {\n  width: calc(var(--default-clickable-area) - 10 px);\n  height: calc(var(--default-clickable-area) - 10 px);\n  border-radius: 17px;\n}\n[data-v-616dda05]  .vc-chrome-body {\n  padding: 14px 0 0 0;\n  background-color: var(--color-main-background);\n}\n[data-v-616dda05]  .vc-chrome-body .vc-input__input {\n  --input-border-radius: var(--border-radius-element, var(--border-radius-large));\n  --input-border-width-offset: calc(var(--border-width-input-focused, 2px) - var(--border-width-input, 2px));\n  width: 100%;\n  height: var(--default-clickable-area);\n  margin: 0;\n  padding-inline: calc(var(--border-radius-large) + var(--input-border-width-offset));\n  padding-block: var(--input-border-width-offset);\n  border: var(--border-width-input, 2px) solid var(--color-border-maxcontrast);\n  border-radius: var(--input-border-radius);\n  font-size: var(--default-font-size);\n  color: var(--color-main-text);\n  box-shadow: none;\n}\n[data-v-616dda05]  .vc-chrome-body .vc-input__input:active:not([disabled]),[data-v-616dda05]  .vc-chrome-body .vc-input__input:hover:not([disabled]),[data-v-616dda05]  .vc-chrome-body .vc-input__input:focus:not([disabled]) {\n  --input-border-width-offset: 0px;\n  border-color: var(--color-main-text);\n  border-width: var(--border-width-input-focused, 2px);\n  box-shadow: 0 0 0 2px var(--color-main-background) !important;\n}\n[data-v-616dda05]  .vc-chrome-body .vc-input__input:active:not([disabled]) + .vc-input__label,[data-v-616dda05]  .vc-chrome-body .vc-input__input:hover:not([disabled]) + .vc-input__label,[data-v-616dda05]  .vc-chrome-body .vc-input__input:focus:not([disabled]) + .vc-input__label {\n  color: var(--color-main-text);\n}\n[data-v-616dda05]  .vc-chrome-body .vc-input__label {\n  position: absolute;\n  inset-inline: var(--border-width-input-focused, 2px);\n  inset-block-start: calc(-1.5 * var(--font-size-small, 13px) / 2);\n  max-width: fit-content;\n  margin-inline: calc(var(--border-radius-large) - var(--default-grid-baseline));\n  margin-block: 0;\n  padding-inline: var(--default-grid-baseline);\n  font-family: var(--font-face);\n  font-size: var(--font-size-small, 13px);\n  line-height: 1.5;\n  font-weight: 500;\n  color: var(--color-text-maxcontrast);\n  background-color: var(--color-main-background);\n  pointer-events: none;\n}\n[data-v-616dda05]  .vc-chrome-toggle-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  margin-left: 6px;\n  filter: var(--background-invert-if-dark);\n}\n[data-v-616dda05]  .vc-chrome-toggle-icon {\n  width: 24px;\n  height: 24px;\n  margin: 0;\n}\n[data-v-616dda05]  .vc-chrome-toggle-icon-highlight {\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  inset: 0;\n}\n[data-v-616dda05]  .vc-chrome-saturation-wrap {\n  border-radius: 3px;\n}\n[data-v-616dda05]  .vc-chrome-saturation-circle {\n  width: 20px;\n  height: 20px;\n}\n.slide-enter[data-v-616dda05] {\n  transform: translateX(-50%);\n  opacity: 0;\n}\n.slide-enter-to[data-v-616dda05] {\n  transform: translateX(0);\n  opacity: 1;\n}\n.slide-leave[data-v-616dda05] {\n  transform: translateX(0);\n  opacity: 1;\n}\n.slide-leave-to[data-v-616dda05] {\n  transform: translateX(-50%);\n  opacity: 0;\n}\n.slide-enter-active[data-v-616dda05], .slide-leave-active[data-v-616dda05] {\n  transition: all 50ms ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
